import React from "react";
import { motion } from "framer-motion";
import { ASSETS } from "@/data/site";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, delay, ease: [0.2, 0.6, 0.2, 1] },
});

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#FDFBF7] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20 items-center">
        <motion.div
          {...fade(0)}
          className="md:col-span-5 relative"
        >
          <div className="relative overflow-hidden bg-[#F2EFE9]">
            <img
              src={ASSETS.maternityCouple}
              alt="A tender maternity moment"
              className="w-full h-[520px] md:h-[640px] object-contain"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 hidden md:block">
            <div className="border border-[#C5A059] px-6 py-4 bg-[#FDFBF7]">
              <p className="overline">Est. lsb-studio</p>
              <p className="font-serif-display text-2xl mt-1">NY · NJ</p>
            </div>
          </div>
        </motion.div>

        <motion.div {...fade(0.15)} className="md:col-span-7 md:pl-10">
          <p className="overline mb-6">Our philosophy</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
            We believe a photograph
            <br />
            <span className="italic font-light">should feel</span> like
            remembering.
          </h2>

          <div className="mt-10 space-y-6 text-[#4A4A4A] text-base md:text-lg leading-relaxed max-w-xl">
            <p>
              lsb-studio is a boutique photography practice devoted to the quiet
              spectacle of real life — the held breath before a vow, the slow
              curve of a new belly, the unrepeatable joy of a celebration.
            </p>
            <p>
              Every session is approached as an editorial — directed with
              cinematic light, finished with archival care, and delivered as a
              keepsake worthy of being passed down.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-8 max-w-md">
            <div>
              <p className="font-serif-display text-3xl md:text-4xl">12+</p>
              <p className="overline mt-2">Years</p>
            </div>
            <div>
              <p className="font-serif-display text-3xl md:text-4xl">400+</p>
              <p className="overline mt-2">Stories</p>
            </div>
            <div>
              <p className="font-serif-display text-3xl md:text-4xl">4</p>
              <p className="overline mt-2">Specialties</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
